import { createI18n } from 'vue-i18n'
import en from './locales/en'
import ru from './locales/ru'

const supported = ['ru', 'en']
const fromWindow = typeof window !== 'undefined' ? window.__APP_LOCALE__ : null
const fromEnv = import.meta.env.VITE_APP_LOCALE
const locale = supported.includes(fromWindow) ? fromWindow : supported.includes(fromEnv) ? fromEnv : 'ru'

export default createI18n({
  legacy: true,
  globalInjection: true,
  locale,
  fallbackLocale: 'en',
  messages: { en, ru },
})
